export default __webpack_public_path__ + "static/taskdefinition8-796728c5043bfa6635dc30757aec775e.png";